var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-108"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.62,344.53s11.93-17.08,3.7-36.68-3.39-27.07-3.39-27.07l8,15.87s7.49-11.72,4.55-25.49,3.83-36.92,3.83-36.92-2.44,26.8,1.84,37.44c0,0,6.26-10.32,8.49-20.74s9.07-31,9.07-31l-10.48,63.8,23-28.79s-23.41,39-26.53,46.61l25.44-12.7s-12.46,19.56-22.33,23.3-20.58,34.24-20.58,34.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.1,352.2s-10.36-21,2.07-41.32,8.33-29.46,8.33-29.46L395,297.68s-6.35-14.27-.75-29.05,2-41.61,2-41.61-1.81,30.15-8.35,41.24c0,0-5.2-12.51-5.92-24.45s-4.84-35.93-4.84-35.93l.87,72.56-20.62-35.82s19.4,47.22,21.58,56.19l-26.09-18.37c1.64-.66,16.42,21.44,20.85,29.61,5.65,10.4,17.06,41.45,17.06,41.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.65 343.08 423.46 343.08 418.46 382.76 366.65 382.76 361.65 343.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.78,
    y: 109.65,
    width: 178.91,
    height: 124.62,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.48,
    y: 114.58,
    width: 170.4,
    height: 115,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.99 114.58 96.28 229.58 80.56 229.58 111.2 114.58 126.99 114.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140 114.58 109.3 229.58 103.51 229.58 134.21 114.58 140 114.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.88 144.87 219.26 229.58 213.47 229.58 241.88 123.18 241.88 144.87",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.24 114.58 236.82 114.58 206.36 229.58 190.57 229.58 221.24 114.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.23,
    y: 109.65,
    width: 4,
    height: 124.62,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.08,
    y: 116.48,
    width: 147.69,
    height: 82.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.23,
    y: 118.86,
    width: 141.39,
    height: 78.11,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.16,
    y: 127.83,
    width: 1.05,
    height: 62.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.39,
    y: 188.8,
    width: 121.06,
    height: 1.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.22 180.92 302.28 180.23 320.74 155.04 323.56 158.62 335.55 146.28 343.1 152.27 357.61 131.31 368.86 166.62 374.82 155.75 377.76 157.78 392.08 146.53 394.06 151.16 415.15 136.08 415.83 137.03 393.56 152.96 391.6 148.39 377.8 159.22 375.22 157.44 368.57 169.57 357.22 133.93 343.35 153.96 335.65 147.85 323.47 160.39 320.77 156.97 303.22 180.92",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-108"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-108",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-108"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "167.67 418.98 161.55 418.98 150.54 265.74 158.67 265.74 167.67 418.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.68 418.98 161.55 418.98 151.08 273.35 150.54 265.98 158.67 265.98 159.11 273.35 167.68 418.98",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.11 272.98 151.08 272.98 150.54 265.98 158.67 265.98 159.11 272.98",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.63 418.98 306.51 418.98 305.51 265.74 313.63 265.74 312.63 418.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.64 265.98 313.48 290.71 312.64 418.98 306.51 418.98 305.67 290.71 305.51 265.98 313.64 265.98",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.64 265.98 313.48 290.98 305.67 290.98 305.51 265.98 313.64 265.98",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.67 418.98 371.55 418.98 360.54 265.74 368.67 265.74 377.67 418.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.68 418.98 371.55 418.98 361.08 273.35 360.54 265.98 368.67 265.98 369.11 273.35 377.68 418.98",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.11 272.98 361.08 272.98 360.54 265.98 368.67 265.98 369.11 272.98",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.59 418.98 91.47 418.98 100.47 265.74 108.6 265.74 97.59 418.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.6 265.98 108.06 273.35 97.59 418.98 91.47 418.98 100.03 273.35 100.47 265.98 108.6 265.98",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.47 265.98 108.6 265.98 108.06 272.98 100.03 272.98 100.47 265.98",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,261.9H375.11a0,0,0,0,1,0,0v5.51a2.16,2.16,0,0,1-2.16,2.16H96.19A2.16,2.16,0,0,1,94,267.41V261.9a0,0,0,0,1,0,0Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,261.9H375.11a0,0,0,0,1,0,0v5.51a2.16,2.16,0,0,1-2.16,2.16H96.19A2.16,2.16,0,0,1,94,267.41V261.9a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.03,
    y: 261.9,
    width: 281.08,
    height: 3.84,
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.91,262.9H90.23a2.16,2.16,0,0,1-2.16-2.16h0a2.17,2.17,0,0,1,2.16-2.17H378.91a2.17,2.17,0,0,1,2.16,2.17h0A2.16,2.16,0,0,1,378.91,262.9Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.91,262.9H90.23a2.16,2.16,0,0,1-2.16-2.16h0a2.17,2.17,0,0,1,2.16-2.17H378.91a2.17,2.17,0,0,1,2.16,2.17h0A2.16,2.16,0,0,1,378.91,262.9Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.61 258.57 228.59 254.84 269.15 254.84 287.82 256.71 288.53 258.57 227.61 258.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.15 254.84 269.15 258.57 227.61 258.57 228.59 254.84 269.15 254.84",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--profile-2--inject-108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.14,
    y: 80.62,
    width: 106.15,
    height: 75.74,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.14,
    y: 80.62,
    width: 106.15,
    height: 75.74,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.31,
    y: 82.9,
    width: 64.62,
    height: 3.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.34,
    cy: 93.19,
    r: 7.64,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 105.85,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 105.85,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.73,
    y: 105.85,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.73,
    y: 105.85,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.76,
    y: 105.85,
    width: 13.46,
    height: 25.29,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.76,
    y: 105.85,
    width: 13.46,
    height: 25.29,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 118.88,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 118.88,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 136.32,
    width: 19.26,
    height: 19.26,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 136.32,
    width: 19.26,
    height: 19.26,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.42,
    y: 136.32,
    width: 9.63,
    height: 9.63,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.42,
    y: 136.32,
    width: 9.63,
    height: 9.63,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.42,
    y: 146.39,
    width: 9.63,
    height: 9.19,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.42,
    y: 146.39,
    width: 9.63,
    height: 9.19,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.59,
    y: 136.32,
    width: 9.63,
    height: 9.63,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.59,
    y: 136.32,
    width: 9.63,
    height: 9.63,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.59,
    y: 146.39,
    width: 9.63,
    height: 9.19,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.59,
    y: 146.39,
    width: 9.63,
    height: 9.19,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.73,
    y: 118.88,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.73,
    y: 118.88,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.22,
    y: 105.85,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.22,
    y: 105.85,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 105.85,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 105.85,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.28,
    y: 105.85,
    width: 13.46,
    height: 25.29,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.28,
    y: 105.85,
    width: 13.46,
    height: 25.29,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.22,
    y: 118.88,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.22,
    y: 118.88,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.22,
    y: 136.32,
    width: 19.26,
    height: 19.26,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.22,
    y: 136.32,
    width: 19.26,
    height: 19.26,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.94,
    y: 136.32,
    width: 9.63,
    height: 9.63,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.94,
    y: 136.32,
    width: 9.63,
    height: 9.63,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.94,
    y: 146.39,
    width: 9.63,
    height: 9.19,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.94,
    y: 146.39,
    width: 9.63,
    height: 9.19,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.11,
    y: 136.32,
    width: 9.63,
    height: 9.63,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.11,
    y: 136.32,
    width: 9.63,
    height: 9.63,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.11,
    y: 146.39,
    width: 9.63,
    height: 9.19,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.11,
    y: 146.39,
    width: 9.63,
    height: 9.19,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 118.88,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 118.88,
    width: 12.25,
    height: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.51,
    y: 132.24,
    width: 8.71,
    height: 2.64,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.51,
    y: 132.24,
    width: 8.71,
    height: 2.64,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.03,
    y: 132.24,
    width: 8.71,
    height: 2.64,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.03,
    y: 132.24,
    width: 8.71,
    height: 2.64,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.29,
    y: 94.41,
    width: 17.12,
    height: 2.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.29,
    y: 98.94,
    width: 24.18,
    height: 0.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.29,
    y: 100.36,
    width: 26.32,
    height: 0.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.45,
    y: 90.55,
    width: 7.29,
    height: 2.64,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.45,
    y: 90.55,
    width: 7.29,
    height: 2.64,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.19,
    y: 90.55,
    width: 8.71,
    height: 2.64,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.19,
    y: 90.55,
    width: 8.71,
    height: 2.64,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 132.24,
    width: 11.19,
    height: 1.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.94,93.21a7.63,7.63,0,1,0-14.28,3.73,2.39,2.39,0,0,1,1.48-.87,1.94,1.94,0,0,1,.34,0,17.21,17.21,0,0,1,2.27,0,29,29,0,0,1,3.27.39,14.27,14.27,0,0,1,2.16.67h0a2.28,2.28,0,0,1,1.34,1.46c.1.27.19.55.26.82A7.61,7.61,0,0,0,290.94,93.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.52,98.58a2.28,2.28,0,0,0-1.34-1.46h0a14.27,14.27,0,0,0-2.16-.67,29,29,0,0,0-3.27-.39,17.21,17.21,0,0,0-2.27,0h0a1.94,1.94,0,0,0-.34,0,2.39,2.39,0,0,0-1.48.87,7.62,7.62,0,0,0,6.65,3.9,7.33,7.33,0,0,0,3.13-.67,7.4,7.4,0,0,0,1.34-.77C287.71,99.13,287.62,98.85,287.52,98.58Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.52,92.41c.08,1.08.05,3-.77,3.65a10.21,10.21,0,0,1,2.57,2.14,3.73,3.73,0,0,0,.7-1.75c-1.14-.42-1-1.29-.7-2.08Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.25,93.21l1.07,1.16a2.47,2.47,0,0,0-.17.57,1.47,1.47,0,0,1-1-1.16A1.57,1.57,0,0,1,282.25,93.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,89.17c1,.59.29,3-.22,3.18C284.15,92.69,284.06,88.44,285.33,89.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.59,90.82c-.09,1.43-.21,2.27.42,3.08a1.91,1.91,0,0,0,3.3-.58c.46-1.25.52-3.38-.81-4.12A2,2,0,0,0,281.59,90.82Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,89.56c-.14.83.54,3.18,1.14,3.2s.94-1.26.78-2.47c.57-.1,4.08.35,3.64-1.14a1.43,1.43,0,0,0-1.23-.93,3.26,3.26,0,0,0-1.74-.85c.47.52.46.64.15.57a3.53,3.53,0,0,1-1.05-.43,1.36,1.36,0,0,0,0,.63c-.18-.08-.3-.38-1.5-.24.47.36.29.57.15.61a1.47,1.47,0,0,1-1.07,0A1.57,1.57,0,0,0,280.57,89.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.75,92.31a1.39,1.39,0,0,0,.78.7c.45.16.7-.24.6-.68s-.43-1-.89-.93A.62.62,0,0,0,280.75,92.31Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7,91.48c0,.11,0,.21.11.22s.15-.07.16-.19,0-.22-.11-.23S283.71,91.36,283.7,91.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,91.64c0,.11,0,.21.11.22s.15-.07.16-.19,0-.22-.11-.23S285,91.52,285,91.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.59,91.64A4.19,4.19,0,0,0,285,92.7a.67.67,0,0,1-.57,0Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,93a0,0,0,0,0,0,0s0,0,0,0a.91.91,0,0,1-.7-.45s0,0-.05,0a0,0,0,0,0,0,0,1,1,0,0,0,.76.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36,91l.05,0a.57.57,0,0,1,.47-.18.07.07,0,0,0,.08,0s0-.08-.06-.08a.66.66,0,0,0-.59.21.08.08,0,0,0,0,.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.65,91.26h0a.07.07,0,0,0,0-.08.72.72,0,0,0-.44-.45.08.08,0,0,0-.09,0,.09.09,0,0,0,.05.09.5.5,0,0,1,.35.35A.08.08,0,0,0,285.65,91.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--profile-3--inject-108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.95,
    y: 114.06,
    width: 83.25,
    height: 42.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.84,
    y: 117.76,
    width: 105.85,
    height: 66.46,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.84,
    y: 117.76,
    width: 105.85,
    height: 66.46,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.4,
    cy: 136.92,
    r: 7.67,
    transform: "translate(106.6 408.53) rotate(-76.72)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.18 121.36 299.18 136.92 299.18 169.14 371.9 169.14 371.9 136.92 371.9 121.36 299.18 121.36",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.18,
    y: 136.92,
    width: 72.73,
    height: 32.22,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.18,
    y: 121.47,
    width: 72.73,
    height: 15.56,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.18,
    y: 171.16,
    width: 72.73,
    height: 13.06,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.18,
    y: 171.16,
    width: 72.73,
    height: 13.06,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.67,
    y: 121.36,
    width: 19.44,
    height: 61.73,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.67,
    y: 121.36,
    width: 19.44,
    height: 61.73,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.4,
    y: 122.15,
    width: 17.99,
    height: 15.61,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.4,
    y: 122.15,
    width: 17.99,
    height: 15.61,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 145.33,
    width: 10.2,
    height: 1.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 147.14,
    width: 15.41,
    height: 1.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 148.72,
    width: 14.35,
    height: 1.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 154.14,
    width: 52.75,
    height: 1.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 157.12,
    width: 56.8,
    height: 1.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 160.1,
    width: 55.66,
    height: 1.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 163.08,
    width: 53.8,
    height: 1.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.91,
    y: 142.12,
    width: 10.13,
    height: 1.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.91,
    y: 145.25,
    width: 9.16,
    height: 0.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.91,
    y: 152.14,
    width: 10.13,
    height: 1.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.91,
    y: 155.27,
    width: 9.16,
    height: 0.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.91,
    y: 162.17,
    width: 10.13,
    height: 1.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.91,
    y: 165.29,
    width: 9.16,
    height: 0.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.91,
    y: 172.19,
    width: 10.13,
    height: 1.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.91,
    y: 175.32,
    width: 9.16,
    height: 0.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 179.52,
    width: 53.8,
    height: 1.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.18,
    y: 175.59,
    width: 57.42,
    height: 1.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.39,140.32s.4-.08,1-.16A15,15,0,0,1,310,140a28.78,28.78,0,0,1,3.35,0,12,12,0,0,1,1.42.21l.52.11.17,0h0l.1,0h0a4.56,4.56,0,0,1,1.49.91,3.06,3.06,0,0,1,.35.37,7.63,7.63,0,1,0-11.63.47C306.29,141.2,306.85,140.4,307.39,140.32Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.44,144.6a7.63,7.63,0,0,0,6-2.93,3.06,3.06,0,0,0-.35-.37,4.56,4.56,0,0,0-1.49-.91h0l-.1,0h0l-.17,0-.52-.11a12,12,0,0,0-1.42-.21,28.78,28.78,0,0,0-3.35,0,15,15,0,0,0-1.65.17c-.58.08-1,.16-1,.16-.54.08-1.1.88-1.57,1.82A7.65,7.65,0,0,0,311.44,144.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,140a28.78,28.78,0,0,1,3.35,0l.19,0a.6.6,0,0,1,.22.56c-.08.33-.54.44-.94.49a2,2,0,0,1-.08.43l-.13.38-.22-.33a1.9,1.9,0,0,0-.46-.45c-1.94-.05-2.23-1-2.25-1v0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.1,136.23l.89.74,1.22,1a4.13,4.13,0,0,0-.07.49,1.22,1.22,0,0,0,1.08,1.49s1.15.77-.56.91a2.7,2.7,0,0,1-.09.55,2.12,2.12,0,0,0-.55-.53c-1.88,0-2.13-.91-2.13-.91C310.62,139.27,310.34,137.31,310.1,136.23Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.21,138a4.13,4.13,0,0,0-.07.49,1.55,1.55,0,0,1-1.13-1,2,2,0,0,1,0-.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,132.46c.73.33,1.13,2.38.21,2.82S311.66,131.84,313,132.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.73,134.68c.31,1.43.42,2.28,1.26,2.94a1.91,1.91,0,0,0,3.09-1.38c.11-1.33-.42-3.45-1.93-3.86A1.93,1.93,0,0,0,309.73,134.68Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.06,133.25c-.7.31-.3,1.27.17,1.87.66.85,1.36,1.24,1.83.85a2.09,2.09,0,0,0,.34-2.24c.65-.43,3.09.63,3.82-1.15a1.7,1.7,0,0,0-.59-2.06,5,5,0,0,1-3.08,1C309,131.63,307.36,132.43,308.06,133.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,136.17a1.52,1.52,0,0,0,.9.54c.46.08.56-.34.33-.74s-.69-.85-1.1-.74S309.1,135.82,309.4,136.17Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,134.82c0,.12.09.2.17.19s.12-.11.11-.23-.1-.2-.18-.19S312,134.7,312,134.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.32,134.66c0,.12.1.2.17.19s.13-.11.11-.22-.09-.21-.17-.2S313.3,134.54,313.32,134.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.91,134.77a4.52,4.52,0,0,0,.72.94.67.67,0,0,1-.55.17Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.64,136.25a1.06,1.06,0,0,1-.74-.3s0,0,0,0a0,0,0,0,1,0,0,1,1,0,0,0,.82.28s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.51,134.44h0a.08.08,0,0,1,0-.1A.67.67,0,0,1,312,134s.07,0,.07.07a.07.07,0,0,1-.06.07.52.52,0,0,0-.41.28A.08.08,0,0,1,311.51,134.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.82,134.13a.05.05,0,0,1-.05,0,.58.58,0,0,0-.44-.26.08.08,0,0,1-.07-.07.07.07,0,0,1,.07-.07h0a.7.7,0,0,1,.55.32s0,.08,0,.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--profile-4--inject-108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.22,
    y: 154.14,
    width: 77.47,
    height: 29.93,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.54,
    y: 157.83,
    width: 82.03,
    height: 51.12,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.54,
    y: 157.83,
    width: 82.03,
    height: 51.12,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.65,
    y: 192.67,
    width: 17.99,
    height: 15.89,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.98,
    y: 159.01,
    width: 74.67,
    height: 3.87,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.98,
    y: 159.01,
    width: 74.67,
    height: 3.87,
    style: {
      fill: "#fff",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.98,
    y: 165.06,
    width: 74.67,
    height: 25,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.98,
    y: 165.06,
    width: 74.67,
    height: 25,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.82,
    cy: 184.26,
    r: 7.65,
    transform: "translate(81.64 471.68) rotate(-76.72)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.66,
    y: 192.67,
    width: 54.99,
    height: 15.89,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.66,
    y: 192.67,
    width: 54.99,
    height: 15.89,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.72,
    y: 170.43,
    width: 52.86,
    height: 2.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.72,
    y: 176.39,
    width: 52.86,
    height: 2.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.72,
    y: 182.89,
    width: 52.86,
    height: 2.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.15,
    y: 160.36,
    width: 16.03,
    height: 1.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.64,
    y: 160.53,
    width: 9.17,
    height: 1.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.44,
    y: 195.98,
    width: 16.03,
    height: 1.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.44,
    y: 198.03,
    width: 16.03,
    height: 1.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.44,
    y: 200.07,
    width: 16.03,
    height: 1.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.44,
    y: 202.12,
    width: 16.03,
    height: 1.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.44,
    y: 204.16,
    width: 16.03,
    height: 1.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.72,
    y: 200.16,
    width: 52.86,
    height: 2.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.72,
    y: 203.74,
    width: 52.86,
    height: 2.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,184.35a7.63,7.63,0,1,0-10.91,6.89c-.11-.35-.23-.71-.36-1.1l-.39-1.17a19.77,19.77,0,0,1,2.63-.64,22.57,22.57,0,0,1,2.85-.3c1.23,0,2.65.13,2.65.13s.2.05.33,1.36c0,.26.05.59.07,1A7.61,7.61,0,0,0,346.45,184.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.05,181.08a2.1,2.1,0,0,1,.89,1.8,22.81,22.81,0,0,0-.13,3.11,4.87,4.87,0,0,1-.41,2.11,7.15,7.15,0,0,0-.22-1.16s0,.31-.43.43-3.79.2-4.55-.43.83-5.7,1.7-6A9.74,9.74,0,0,1,341.05,181.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,188.16s-1.42-.13-2.65-.13a22.57,22.57,0,0,0-2.85.3,19.77,19.77,0,0,0-2.63.64l.39,1.17c.13.39.25.75.36,1.1a7.63,7.63,0,0,0,7.78-.73c0-.4-.05-.73-.07-1C343.12,188.21,342.92,188.16,342.92,188.16Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,188.16s-1.42-.13-2.65-.13a22.57,22.57,0,0,0-2.85.3,19.77,19.77,0,0,0-2.63.64l.39,1.17c.13.39.25.75.36,1.1a7.63,7.63,0,0,0,7.78-.73c0-.4-.05-.73-.07-1C343.12,188.21,342.92,188.16,342.92,188.16Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.24,181.17c.58-1.18,3.67-1.19,4.27-.06.78,1.44,2.34,2.89,1.87,4.9a1.59,1.59,0,0,0-.24-.58,2,2,0,0,1-1.46,2.2,9.37,9.37,0,0,1-4.92-.3,1.42,1.42,0,0,1-.17-.78.92.92,0,0,0-.09.68,2.17,2.17,0,0,1-.79-2.67C336.3,182.89,336.07,180.91,337.24,181.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.74,189.44a2.92,2.92,0,0,1-2-.87c1-.94.17-2.56.17-2.56l1.88.35a5,5,0,0,0-.07.79c0,1.15.5,1.16.5,1.16C340.52,188.93,339.74,189.44,339.74,189.44Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.76,186.36a5,5,0,0,0-.07.79,2.1,2.1,0,0,1-1.81-1.14Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.26,188.74a6.78,6.78,0,0,0,3.55,1.47c1.71,0,2.31-2,2.31-2A9.8,9.8,0,0,0,336.26,188.74Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,181.4c1.55.26,1.9,1.17,1.74,2.78-.2,2-.88,3.35-2.73,2.6C336.34,185.75,337.29,181,339.85,181.4Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.61,183.93a3.42,3.42,0,0,0,.34.71.44.44,0,0,1-.44.11Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.69,183.64c0,.13-.1.22-.19.21a.22.22,0,0,1-.12-.26c0-.12.1-.22.19-.2S339.71,183.51,339.69,183.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.53,183.39l.29-.07S339.65,183.53,339.53,183.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.27,183.84c0,.13-.1.22-.18.21s-.14-.12-.12-.25.1-.22.18-.21S341.29,183.72,341.27,183.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.12,183.59l.29-.07S341.24,183.74,341.12,183.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.15,182.76a.05.05,0,0,1,0,0,.06.06,0,0,1,0-.09.85.85,0,0,1,.77-.13.07.07,0,0,1,.05.08.06.06,0,0,1-.09,0,.76.76,0,0,0-.64.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.58,183l-.05,0a.67.67,0,0,0-.53-.22.07.07,0,1,1,0-.13.8.8,0,0,1,.66.25.07.07,0,0,1,0,.09S341.6,183,341.58,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.72,183.71a4.68,4.68,0,0,0,1-2.14s3.27-.73,2.89,2.4c0,0,.77-2.7-1.87-3.22s-3,4.55-1.79,5.94C338,186.69,337.14,184.43,337.72,183.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,184.08a.68.68,0,0,0-.62-.74c-.49,0-.89.91.26,1.35C337.73,184.75,337.85,184.6,337.92,184.08Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.39,181.22a4.61,4.61,0,0,0,1.4,1,14.56,14.56,0,0,0,2.11.57c-.28,1.41-.22,2.59.46,3.32-.25-.41.15-3.59.11-3.86-.1-.65-.74-1.06-1.48-1.56a3.27,3.27,0,0,0-1.84-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,181.56v1.82a2.08,2.08,0,0,0,.19,1.66,9.73,9.73,0,0,1,.15-2.11l.61-1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.79,189a2.92,2.92,0,0,0-.85,1.24,8,8,0,0,0,1.6,1Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.79,189a2.92,2.92,0,0,0-.85,1.24,8,8,0,0,0,1.6,1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,188.16l.4,2.35a7.9,7.9,0,0,0,1.46-1.4A4.32,4.32,0,0,0,342.92,188.16Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,188.16l.4,2.35a7.9,7.9,0,0,0,1.46-1.4A4.32,4.32,0,0,0,342.92,188.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,185.5h.23s0,0,0,0,0,0-.05,0a1.18,1.18,0,0,1-.94-.37s0,0-.05,0,0,0,0,0A1.23,1.23,0,0,0,340.54,185.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--profile-1--inject-108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.67,
    y: 79.78,
    width: 148.11,
    height: 97.04,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.67,
    y: 79.78,
    width: 148.11,
    height: 97.04,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 93.51,
    width: 35.11,
    height: 75.65,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 93.51,
    width: 35.11,
    height: 75.65,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 82.02,
    width: 141.72,
    height: 7.34,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 82.02,
    width: 141.72,
    height: 7.34,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.97,
    y: 93.51,
    width: 106.61,
    height: 31.92,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.97,
    y: 93.51,
    width: 106.61,
    height: 31.92,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.2,
    y: 129.58,
    width: 104.38,
    height: 7.82,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.2,
    y: 129.58,
    width: 104.38,
    height: 7.82,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.2,
    y: 141.71,
    width: 104.38,
    height: 27.45,
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.2,
    y: 141.71,
    width: 104.38,
    height: 27.45,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.2,
    y: 136.28,
    width: 30.43,
    height: 2.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.2,
    y: 141.71,
    width: 30.43,
    height: 2.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.93,
    y: 102.58,
    width: 30.43,
    height: 2.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.93,
    y: 107.04,
    width: 30.43,
    height: 2.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.93,
    y: 110.47,
    width: 30.43,
    height: 2.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.2,
    y: 147.13,
    width: 30.43,
    height: 2.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.2,
    y: 152.56,
    width: 30.43,
    height: 2.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.23,
    y: 132.33,
    width: 100.34,
    height: 2.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.76,
    y: 149.37,
    width: 69.27,
    height: 2.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.76,
    y: 154.28,
    width: 69.27,
    height: 2.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.76,
    y: 159.19,
    width: 69.27,
    height: 2.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.28,
    y: 84.09,
    width: 120.87,
    height: 3.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.41,
    cy: 110.91,
    r: 14.52,
    style: {
      fill: "#fafafa"
    }
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 285.53,
    y1: 175.82,
    x2: 284.97,
    y2: 186.42
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-108"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "137.11 232.13 145 232.13 142.89 254.71 160.58 256.58 160.58 258.15 122.34 258.15 122.34 256.58 134.48 254.71 137.11 232.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.11 232.13 145 232.13 142.89 254.71 160.58 256.58 160.58 258.15 122.34 258.15 122.34 256.58 134.48 254.71 137.11 232.13",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,242.08h73.75a4,4,0,0,0,4-4.4l-4.1-46.85a4.9,4.9,0,0,0-4.79-4.4H101.15a4,4,0,0,0-4,4.4l4.1,46.85A4.89,4.89,0,0,0,106,242.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,239H175.4a3.53,3.53,0,0,0,3.57-3.91l-3.64-41.65a4.35,4.35,0,0,0-4.25-3.91H105.52a3.52,3.52,0,0,0-3.56,3.91l3.64,41.65A4.35,4.35,0,0,0,109.85,239Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,239H175.4a3.53,3.53,0,0,0,3.57-3.91l-3.64-41.65a4.35,4.35,0,0,0-4.25-3.91H105.52a3.52,3.52,0,0,0-3.56,3.91l3.64,41.65A4.35,4.35,0,0,0,109.85,239Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.14 194.5 135.22 194.5 135.2 193.96 164.12 193.96 164.14 194.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.58 196.15 144.71 196.15 144.69 195.61 164.56 195.61 164.58 196.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.66 197.8 148.39 197.8 148.37 197.26 164.63 197.26 164.66 197.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.91 199.45 143.79 199.45 143.77 198.91 164.88 198.91 164.91 199.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.09 201.11 151.08 201.11 151.06 200.57 165.06 200.57 165.09 201.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.7 206.14 136.78 206.14 136.76 205.6 165.67 205.6 165.7 206.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.93 207.79 140.21 207.79 140.18 207.26 165.91 207.26 165.93 207.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.21 209.45 149.95 209.45 149.93 208.91 166.19 208.91 166.21 209.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.37 211.1 145.26 211.1 145.24 210.56 166.35 210.56 166.37 211.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.61 212.75 141.39 212.75 141.37 212.21 166.59 212.21 166.61 212.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.29 215.35 137.38 215.35 137.35 214.81 166.27 214.81 166.29 215.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.74 217 146.86 217 146.84 216.47 166.71 216.47 166.74 217",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.81 218.66 150.55 218.66 150.52 218.12 166.78 218.12 166.81 218.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.06 220.31 145.94 220.31 145.92 219.77 167.03 219.77 167.06 220.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.24 221.96 153.23 221.96 153.21 221.42 167.21 221.42 167.24 221.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.85 227 138.94 227 138.91 226.46 167.83 226.46 167.85 227",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.09 228.65 142.36 228.65 142.33 228.11 168.06 228.11 168.09 228.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.37 230.3 152.1 230.3 152.08 229.76 168.34 229.76 168.37 230.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.53 231.95 147.41 231.95 147.39 231.41 168.5 231.41 168.53 231.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.76 233.6 143.54 233.6 143.52 233.06 168.74 233.06 168.76 233.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,202.76h-9.9a2.43,2.43,0,0,1-2.41-2.2l-.43-4.82a2.42,2.42,0,0,1,2.41-2.63h9.9a2.42,2.42,0,0,1,2.41,2.2l.43,4.81A2.42,2.42,0,0,1,126,202.76Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,202.76h-9.9a2.43,2.43,0,0,1-2.41-2.2l-.43-4.82a2.42,2.42,0,0,1,2.41-2.63h9.9a2.42,2.42,0,0,1,2.41,2.2l.43,4.81A2.42,2.42,0,0,1,126,202.76Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,202.28h-8.82a2.42,2.42,0,0,1-2.41-2.21l-.23-2.52a2.42,2.42,0,0,1,2.41-2.63h8.82a2.42,2.42,0,0,1,2.41,2.2l.22,2.52A2.41,2.41,0,0,1,125.45,202.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.11 196.22 118.65 196.22 118.64 196.02 125.09 196.02 125.11 196.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.81 196.84 118.71 196.84 118.69 196.64 121.79 196.64 121.81 196.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.67 197.46 118.77 197.46 118.75 197.25 122.65 197.25 122.67 197.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.2 198.08 118.82 198.08 118.8 197.87 120.18 197.87 120.2 198.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.77 198.7 118.88 198.7 118.86 198.49 119.75 198.49 119.77 198.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.53 199.28 119.07 199.28 119.06 199.07 125.52 199.07 125.53 199.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.23 199.9 119.13 199.9 119.11 199.69 122.21 199.69 122.23 199.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.09 200.51 119.19 200.51 119.17 200.31 123.07 200.31 123.09 200.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.62 201.13 119.24 201.13 119.22 200.93 120.6 200.93 120.62 201.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.19 201.75 119.3 201.75 119.28 201.55 120.17 201.55 120.19 201.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.9,201.25h-2a.85.85,0,0,1-.85-.75l-.4-3.54a.85.85,0,0,1,.85-.94h2a.85.85,0,0,1,.85.75l.4,3.54A.85.85,0,0,1,117.9,201.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39,201h3.13l-.15-1.12a1.85,1.85,0,0,0-1.21-.48,1.17,1.17,0,0,0,.76-1.12c-.08-.82-.36-1.56-1.19-1.56s-1,.79-1,1.56a1.4,1.4,0,0,0,.71,1.14,1.25,1.25,0,0,0-1.19.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28,213.16H116.82a2.14,2.14,0,0,1-2.13-1.95l-.48-5.38a2.13,2.13,0,0,1,2.12-2.32H126.8a2.14,2.14,0,0,1,2.13,1.94l.48,5.38A2.14,2.14,0,0,1,127.28,213.16Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28,213.16H116.82a2.14,2.14,0,0,1-2.13-1.95l-.48-5.38a2.13,2.13,0,0,1,2.12-2.32H126.8a2.14,2.14,0,0,1,2.13,1.94l.48,5.38A2.14,2.14,0,0,1,127.28,213.16Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7,212.67h-9.39a2.13,2.13,0,0,1-2.12-1.94l-.28-3.09a2.13,2.13,0,0,1,2.13-2.32h9.38a2.13,2.13,0,0,1,2.13,1.94l.28,3.09A2.14,2.14,0,0,1,126.7,212.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.06 206.62 119.6 206.62 119.58 206.41 126.04 206.41 126.06 206.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.75 207.24 119.65 207.24 119.63 207.03 122.73 207.03 122.75 207.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.61 207.86 119.71 207.86 119.69 207.65 123.59 207.65 123.61 207.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.14 208.47 119.76 208.47 119.75 208.27 121.12 208.27 121.14 208.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.71 209.09 119.82 209.09 119.8 208.89 120.69 208.89 120.71 209.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.48 209.68 120.02 209.68 120 209.47 126.46 209.47 126.48 209.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.17 210.29 120.07 210.29 120.06 210.09 123.15 210.09 123.17 210.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.03 210.91 120.13 210.91 120.11 210.71 124.01 210.71 124.03 210.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.56 211.53 120.18 211.53 120.17 211.33 121.54 211.33 121.56 211.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.13 212.15 120.24 212.15 120.22 211.95 121.11 211.95 121.13 212.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47,211.65H117.2a1.19,1.19,0,0,1-1.19-1.06l-.32-2.85a1.18,1.18,0,0,1,1.18-1.32h1.27a1.19,1.19,0,0,1,1.19,1.05l.32,2.86A1.19,1.19,0,0,1,118.47,211.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.33,211.42h3.13l-.15-1.12a1.85,1.85,0,0,0-1.2-.48,1.15,1.15,0,0,0,.75-1.12c-.07-.82-.36-1.56-1.19-1.56s-1,.79-1,1.56a1.4,1.4,0,0,0,.71,1.14c-.5-.15-.85.15-1.19.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.22,223.8H117.79a2.16,2.16,0,0,1-2.14-2l-.48-5.34a2.14,2.14,0,0,1,2.14-2.34h10.43a2.15,2.15,0,0,1,2.15,2l.47,5.34A2.15,2.15,0,0,1,128.22,223.8Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.22,223.8H117.79a2.16,2.16,0,0,1-2.14-2l-.48-5.34a2.14,2.14,0,0,1,2.14-2.34h10.43a2.15,2.15,0,0,1,2.15,2l.47,5.34A2.15,2.15,0,0,1,128.22,223.8Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.64,223.31h-9.35a2.15,2.15,0,0,1-2.15-2l-.27-3A2.16,2.16,0,0,1,118,216h9.35a2.16,2.16,0,0,1,2.15,2l.27,3.05A2.14,2.14,0,0,1,127.64,223.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.02 217.26 120.56 217.26 120.54 217.05 127 217.05 127.02 217.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.71 217.88 120.61 217.88 120.59 217.67 123.69 217.67 123.71 217.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.57 218.5 120.67 218.5 120.65 218.29 124.55 218.29 124.57 218.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.1 219.11 120.72 219.11 120.7 218.91 122.08 218.91 122.1 219.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.67 219.73 120.78 219.73 120.76 219.53 121.65 219.53 121.67 219.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.44 220.31 120.97 220.31 120.96 220.11 127.42 220.11 127.44 220.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.13 220.93 121.03 220.93 121.01 220.73 124.11 220.73 124.13 220.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.99 221.55 121.09 221.55 121.07 221.35 124.97 221.35 124.99 221.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.52 222.17 121.14 222.17 121.12 221.97 122.5 221.97 122.52 222.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.09 222.79 121.2 222.79 121.18 222.59 122.07 222.59 122.09 222.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,222.29h-1.45a1.09,1.09,0,0,1-1.09-1l-.35-3a1.11,1.11,0,0,1,1.1-1.23h1.45a1.12,1.12,0,0,1,1.1,1l.34,3A1.11,1.11,0,0,1,119.52,222.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29,222.06h3.13l-.15-1.12a1.85,1.85,0,0,0-1.21-.48,1.16,1.16,0,0,0,.76-1.13c-.08-.81-.36-1.56-1.19-1.56s-1,.8-1,1.56a1.4,1.4,0,0,0,.71,1.15c-.5-.15-.85.15-1.19.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54,234.19H118.42a1.81,1.81,0,0,1-1.8-1.65l-.54-6a1.81,1.81,0,0,1,1.8-2H129a1.82,1.82,0,0,1,1.81,1.66l.54,6A1.81,1.81,0,0,1,129.54,234.19Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54,234.19H118.42a1.81,1.81,0,0,1-1.8-1.65l-.54-6a1.81,1.81,0,0,1,1.8-2H129a1.82,1.82,0,0,1,1.81,1.66l.54,6A1.81,1.81,0,0,1,129.54,234.19Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,233.71h-10a1.82,1.82,0,0,1-1.81-1.65l-.33-3.73a1.82,1.82,0,0,1,1.81-2h10a1.81,1.81,0,0,1,1.8,1.65l.34,3.74A1.81,1.81,0,0,1,129,233.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 227.66 121.5 227.66 121.48 227.45 127.94 227.45 127.96 227.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.65 228.27 121.55 228.27 121.53 228.07 124.64 228.07 124.65 228.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 228.89 121.61 228.89 121.59 228.69 125.5 228.69 125.51 228.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.04 229.51 121.67 229.51 121.65 229.31 123.02 229.31 123.04 229.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.61 230.13 121.72 230.13 121.7 229.93 122.59 229.93 122.61 230.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.38 230.71 121.92 230.71 121.9 230.51 128.36 230.51 128.38 230.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.07 231.33 121.97 231.33 121.96 231.13 125.06 231.13 125.07 231.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.93 231.95 122.03 231.95 122.01 231.75 125.92 231.75 125.93 231.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.46 232.57 122.08 232.57 122.07 232.37 123.44 232.37 123.46 232.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.03 233.19 122.14 233.19 122.12 232.99 123.01 232.99 123.03 233.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.33,232.69h-1.2a1.23,1.23,0,0,1-1.22-1.09l-.32-2.78a1.24,1.24,0,0,1,1.23-1.37H120a1.22,1.22,0,0,1,1.22,1.09l.32,2.78A1.23,1.23,0,0,1,120.33,232.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,232.46h3.12l-.15-1.12a1.85,1.85,0,0,0-1.2-.49,1.14,1.14,0,0,0,.75-1.12c-.07-.81-.36-1.56-1.19-1.56s-1,.8-1,1.56a1.4,1.4,0,0,0,.72,1.15,1.26,1.26,0,0,0-1.2.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-108"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.18 232.06 234.19 232.06 232.05 254.98 250.01 256.88 250.01 258.47 211.19 258.47 211.19 256.88 223.51 254.98 226.18 232.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.18 232.06 234.19 232.06 232.05 254.98 250.01 256.88 250.01 258.47 211.19 258.47 211.19 256.88 223.51 254.98 226.18 232.06",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,242.15H269.5a4,4,0,0,0,4.07-4.47l-4.16-47.56a5,5,0,0,0-4.86-4.47H189.68a4,4,0,0,0-4.08,4.47l4.16,47.56A5,5,0,0,0,194.62,242.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.51,239h66.55a3.58,3.58,0,0,0,3.62-4L265,192.76a4.42,4.42,0,0,0-4.31-4H194.11a3.58,3.58,0,0,0-3.62,4l3.7,42.28A4.42,4.42,0,0,0,198.51,239Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.51,239h66.55a3.58,3.58,0,0,0,3.62-4L265,192.76a4.42,4.42,0,0,0-4.31-4H194.11a3.58,3.58,0,0,0-3.62,4l3.7,42.28A4.42,4.42,0,0,0,198.51,239Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,227.33l-5.81-26a.62.62,0,0,0-1.08-.27l-5.86,6.74a.62.62,0,0,1-1.07-.26l-.88-3.33a.62.62,0,0,0-1.18-.06l-4.76,12.59a.62.62,0,0,1-.8.36h0a.61.61,0,0,1-.36-.8L202.48,200a.62.62,0,0,1,1.18.07l1.27,4.82a.63.63,0,0,0,1.08.25l5.93-6.82a.61.61,0,0,1,1.07.27l5.39,24.11a.62.62,0,0,0,1.2.06l7.73-22.74a.62.62,0,0,1,1.15-.07l2.39,4.91a.62.62,0,0,0,1.12,0l5.26-11.6a.63.63,0,0,1,1.18.11l6.14,25a.62.62,0,0,0,1.14.17l15.93-27.33a.62.62,0,0,1,.85-.23h0a.61.61,0,0,1,.22.85l-17.47,30a.62.62,0,0,1-1.14-.17l-6-24.53a.62.62,0,0,0-1.17-.11L232,207.8a.62.62,0,0,1-1.12,0l-2.23-4.57a.62.62,0,0,0-1.15.07l-8.18,24.07A.62.62,0,0,1,218.15,227.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.78,
    y: 227.75,
    width: 66.53,
    height: 2.38,
    rx: 1.08,
    transform: "translate(458.09 457.88) rotate(-180)",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.73,232.74a1.37,1.37,0,1,0,1.37-1.37A1.38,1.38,0,0,0,259.73,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.01,
    y: 232.36,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(508.15 465.34) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.01,
    y: 232.36,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(508.15 465.34) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.01,
    y: 233.79,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(508.15 468.21) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.01,
    y: 233.79,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(508.15 468.21) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.01,
    y: 235.23,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(508.15 471.09) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.01,
    y: 235.23,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(508.15 471.09) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.91,232.74a1.37,1.37,0,1,0,1.37-1.37A1.38,1.38,0,0,0,242.91,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.19,
    y: 232.36,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(474.51 465.34) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.19,
    y: 232.36,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(474.51 465.34) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.19,
    y: 233.79,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(474.51 468.21) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.19,
    y: 233.79,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(474.51 468.21) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.19,
    y: 235.23,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(474.51 471.09) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.19,
    y: 235.23,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(474.51 471.09) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.3,232.74a1.37,1.37,0,1,0,1.37-1.37A1.38,1.38,0,0,0,226.3,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.58,
    y: 232.36,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(441.29 465.34) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.58,
    y: 232.36,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(441.29 465.34) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.58,
    y: 233.79,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(441.29 468.21) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.58,
    y: 233.79,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(441.29 468.21) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.58,
    y: 235.23,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(441.29 471.09) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.58,
    y: 235.23,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(441.29 471.09) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.31,232.74a1.37,1.37,0,1,0,1.37-1.37A1.37,1.37,0,0,0,209.31,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.58,
    y: 232.36,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(407.3 465.34) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.58,
    y: 232.36,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(407.3 465.34) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.58,
    y: 233.79,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(407.3 468.21) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.58,
    y: 233.79,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(407.3 468.21) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.58,
    y: 235.23,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(407.3 471.09) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.58,
    y: 235.23,
    width: 8.13,
    height: 0.63,
    rx: 0.28,
    transform: "translate(407.3 471.09) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.14,396.15l-28.81-2.84V352.82H327.91V393.3L299,396.15a5.6,5.6,0,0,0-5.06,5.58v4.33h79.29v-4.33A5.6,5.6,0,0,0,368.14,396.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,396.15l-28.81-2.84V352.82H327.91V393.3L299,396.15a5.6,5.6,0,0,0-5.06,5.58v4.33h79.29v-4.33A5.6,5.6,0,0,0,368.14,396.15Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.97,
    cy: 411.42,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.16,
    cy: 411.42,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.95,325.46H341.3a0,0,0,0,1,0,0v31.93a4.13,4.13,0,0,1-4.13,4.13h-7.09a4.13,4.13,0,0,1-4.13-4.13V325.46A0,0,0,0,1,325.95,325.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.95,325.46H341.3a0,0,0,0,1,0,0v31.93a4.13,4.13,0,0,1-4.13,4.13h-7.09a4.13,4.13,0,0,1-4.13-4.13V325.46A0,0,0,0,1,325.95,325.46Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.6,324.89s13.65-48.56,15.91-110a13.66,13.66,0,0,1,13.67-13.14H379.7a13.67,13.67,0,0,1,13.68,13.61c.09,22.33-1.47,72.45-14.06,109.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31,324.89H325.6s13.65-48.56,15.91-110a13.66,13.66,0,0,1,13.67-13.14h24.51a13.68,13.68,0,0,1,13.69,13.61C393.47,237.65,391.91,287.77,379.31,324.89Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.12,289.59s-29.14-5.9-57.26-3,13.23,39.61,13.23,39.61h5.81S276,302.85,277.2,297.05s56.42,1.85,56.42,1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.12,289.59s-29.14-5.9-57.26-3,13.23,39.61,13.23,39.61h5.81S276,302.85,277.2,297.05s56.42,1.85,56.42,1.85Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31,324.89H331.6s13.65-48.56,15.91-110a13.66,13.66,0,0,1,13.67-13.14h18.51a13.68,13.68,0,0,1,13.69,13.61C393.47,237.65,391.91,287.77,379.31,324.89Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.54,325.46s14.31-45.68,16.75-112.34a14.82,14.82,0,0,1,14.82-14.25h26.58a14.84,14.84,0,0,1,14.84,14.76c.1,24.22-1.59,73.72-15.25,114Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.54,325.46s14.31-45.68,16.75-112.34a14.82,14.82,0,0,1,14.82-14.25h26.58a14.84,14.84,0,0,1,14.84,14.76c.1,24.22-1.59,73.72-15.25,114Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.15,317.91h89.92a0,0,0,0,1,0,0v6.69a5,5,0,0,1-5,5H286.15a5,5,0,0,1-5-5v-6.69A0,0,0,0,1,281.15,317.91Z",
    transform: "translate(652.23 647.5) rotate(180)",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.15,317.91h89.92a0,0,0,0,1,0,0v6.69a5,5,0,0,1-5,5H286.15a5,5,0,0,1-5-5v-6.69A0,0,0,0,1,281.15,317.91Z",
    transform: "translate(652.23 647.5) rotate(180)",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.95,
    y: 323.75,
    width: 102.33,
    height: 5.84,
    rx: 2.01,
    transform: "translate(658.23 653.35) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.95,
    y: 323.75,
    width: 102.33,
    height: 5.84,
    rx: 2.01,
    transform: "translate(658.23 653.35) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.01,
    y: 323.75,
    width: 45.27,
    height: 5.84,
    rx: 2.01,
    transform: "translate(715.29 653.35) rotate(180)",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.57,290.2s1.9-6.51-26.23-3.65,13.23,39.61,13.23,39.61h5.81s-21.92-23.31-20.7-29.11,25.39,2.46,25.39,2.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.57,290.2s1.9-6.51-26.23-3.65,13.23,39.61,13.23,39.61h5.81s-21.92-23.31-20.7-29.11,25.39,2.46,25.39,2.46Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.53,136l2.2,2.45a3.86,3.86,0,0,1,.88,3.4l-1.27,5.66a7.15,7.15,0,0,1-4.22,5l-1.32.55c-3.93-3.82-5.35-10.85-5.35-10.85l-.63-2a3.2,3.2,0,0,1,2-4.09l3.86-1.29A3.67,3.67,0,0,1,197.53,136Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.38,161.8l-.24.37-.19.27-.35.49-.7.91c-.47.58-.94,1.13-1.42,1.66-.95,1.07-2,2.05-3,3a57.11,57.11,0,0,1-6.48,5.12c-1.13.77-2.28,1.49-3.44,2.19s-2.35,1.34-3.55,1.95a72.57,72.57,0,0,1-7.32,3.3l-.3.12a5.13,5.13,0,0,1-.74.21,10.91,10.91,0,0,1-4.27-.1,12.49,12.49,0,0,1-3.44-1.37,19,19,0,0,1-4.56-3.81,34.62,34.62,0,0,1-3.11-4.1c-.9-1.39-1.71-2.78-2.45-4.19s-1.42-2.83-2.06-4.25-1.21-2.87-1.77-4.31-1.06-2.9-1.54-4.36c-.23-.73-.46-1.47-.68-2.2s-.42-1.47-.62-2.26a2.85,2.85,0,0,1,5.29-2l0,.08,1,1.91c.34.64.68,1.28,1,1.92.69,1.28,1.4,2.55,2.12,3.8s1.47,2.49,2.23,3.7,1.52,2.4,2.33,3.54,1.61,2.25,2.47,3.28a29.14,29.14,0,0,0,2.6,2.77,10.23,10.23,0,0,0,2.43,1.71,2.55,2.55,0,0,0,.74.2c.14,0,.15,0,.17-.07l-1,.33c2.11-1,4.15-2.18,6.14-3.36,1-.6,2-1.23,2.92-1.87s1.9-1.29,2.81-2c.45-.34.91-.69,1.35-1s.88-.71,1.32-1.07c.87-.72,1.7-1.47,2.51-2.22s1.58-1.54,2.31-2.33c.37-.39.71-.78,1-1.17.17-.19.33-.39.47-.57l.21-.26.08-.11,0,0h0l0,0a5.73,5.73,0,0,1,9.62,6.22Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,150.3c4.72,9,9.67,15.74,15.1,20.46,5.6-2.85,20.93-16.65,23.69-18l.44,18.05c-6.88,6.69-18.63,13.23-22.25,13.65-10.7,2.35-16.95-12.83-23.72-30.23Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,152.79s-9.65,10.89-.54,78.3H286c.34-7.44-4.34-43.72,2.84-78.77a126.05,126.05,0,0,0-16.22-2,179.07,179.07,0,0,0-20.6,0A91.32,91.32,0,0,0,238.06,152.79Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.04,
    y: 197.56,
    width: 2.67,
    height: 19.89,
    transform: "translate(-66.78 237.21) rotate(-41.17)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.04,
    y: 197.56,
    width: 2.67,
    height: 19.89,
    transform: "translate(-66.78 237.21) rotate(-41.17)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.81,
    cy: 191.88,
    r: 11.56,
    transform: "translate(59.42 447.29) rotate(-86.17)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.35,185.29a10,10,0,1,1-14.13-.95A10,10,0,0,1,276.35,185.29Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.35,185.29a10,10,0,1,1-14.13-.95A10,10,0,0,1,276.35,185.29Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.86,184.39a2,2,0,1,1-2.88-.2A2,2,0,0,1,271.86,184.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.12,131.71c-.94,5.37-1.77,15.19,2,18.68,0,0-4.9,7.37-12.81,7.72-6.85.3-3.81-7.36-3.81-7.36,5.94-1.56,5.69-6,4.56-10.11Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,135.35l-5.93,5.29a17.18,17.18,0,0,1,.58,2.94c2.27-.38,7.16-5.24,7.35-7.62C268.16,135,266.28,136.3,266,135.35Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.07,208.12l1.81-2.76a3.83,3.83,0,0,1,3.05-1.73l5.79-.23a7.13,7.13,0,0,1,5.95,2.77l.87,1.13c-2.68,4.78-9.09,8-9.09,8l-1.73,1.11a3.19,3.19,0,0,1-4.46-.86L275,212.14A3.69,3.69,0,0,1,275.07,208.12Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.91,156.17l.42.14.31.11.56.22c.37.14.72.29,1.06.43.68.3,1.33.62,2,1,1.28.64,2.49,1.36,3.67,2.1a57.16,57.16,0,0,1,6.62,4.93c1,.89,2,1.81,3,2.75s1.91,1.92,2.81,2.92a72.85,72.85,0,0,1,5.07,6.22l.2.27a3.37,3.37,0,0,1,.39.66,10.54,10.54,0,0,1,1,4.14,11.81,11.81,0,0,1-.43,3.68,18.7,18.7,0,0,1-2.5,5.39,33.07,33.07,0,0,1-3.15,4.06c-1.11,1.23-2.24,2.38-3.41,3.46s-2.37,2.11-3.58,3.09-2.45,1.92-3.7,2.83-2.52,1.77-3.81,2.61l-1.95,1.23c-.67.4-1.31.78-2,1.18a2.85,2.85,0,0,1-3.32-4.58l.06-.06,1.59-1.46,1.59-1.49c1.06-1,2.1-2,3.12-3s2-2.06,3-3.1,1.92-2.1,2.81-3.17,1.76-2.15,2.53-3.24a29.57,29.57,0,0,0,2-3.23,9.93,9.93,0,0,0,1-2.79,2,2,0,0,0,0-.76c0-.14-.08-.14-.11-.15l.59.92c-1.55-1.77-3.18-3.44-4.84-5.06-.83-.81-1.69-1.58-2.56-2.34s-1.74-1.49-2.64-2.2l-1.35-1-1.37-1c-.92-.65-1.87-1.26-2.8-1.85s-1.9-1.13-2.85-1.63c-.47-.26-.94-.48-1.4-.7l-.67-.31-.31-.13-.13,0-.05,0h0a5.73,5.73,0,1,1,3.52-10.9Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.49,202.72c7.49-6.9,12.69-13.42,15.85-19.88-4.21-4.68-17.18-12.78-19.37-14.23s-6.45-4.79-6.45-10.69c0-7.85,10.29-5.6,10.29-5.6,8.24,4.91,26.95,21.76,28.3,25.15,5,9.72-8,19.69-23.06,30.74Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,113.49C259.6,115.9,258,120,250,126.34c-3.25-4.22-3.79-12.41-1.21-14.47S253,111.41,256.06,113.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,120.09c-.39,8.65-.18,13.73-4.46,18.24-6.45,6.79-17.19,3-19.4-5.58-2-7.73-1-20.58,7.38-24.16a11.81,11.81,0,0,1,16.48,11.5Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,122.68c0,.7-.35,1.28-.81,1.28s-.84-.55-.85-1.25.34-1.28.8-1.29S258.36,122,258.42,122.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.42,122.83c0,.7-.35,1.28-.81,1.28s-.85-.55-.86-1.26.36-1.28.81-1.29S250.41,122.12,250.42,122.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,123.11a25.09,25.09,0,0,1-3.26,6.08,4.05,4.05,0,0,0,3.37.57Z",
    style: {
      fill: "#d08245"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.56,120.12a.4.4,0,0,0,.26-.06.41.41,0,0,0,.08-.58,4.07,4.07,0,0,0-3.39-1.65.4.4,0,0,0-.38.42v0a.43.43,0,0,0,.45.37h0a3.25,3.25,0,0,1,2.66,1.33A.43.43,0,0,0,260.56,120.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.74,120.19a.42.42,0,0,0,.37-.24A3.27,3.27,0,0,1,249.4,118a.41.41,0,0,0-.11-.82,4.13,4.13,0,0,0-2.93,2.38.42.42,0,0,0,.2.55h0A.39.39,0,0,0,246.74,120.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.71,112.49c-4,1.45-3.45,5.8,2.76,13.93,4.19-3.29,6.72-11.11,4.71-13.73S271.22,111.23,267.71,112.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.52,126.93a8.22,8.22,0,0,1-3.83,5c-2.51,1.42-4.45-.66-4.34-3.39.11-2.46,1.55-6.16,4.35-6.46S276.2,124.35,275.52,126.93Z",
    style: {
      fill: "#e6ae76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.8,112.88s1-4.79-1.73-7.52-14-2-20.29-1-12.36,8.54-12.36,8.54h9.93c-1,.43-1.88,1.8-2.73,3.24,8.29-.69,17.74-.89,21.08-3.7l.44,1,2.32.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,133a19.89,19.89,0,0,0,6.5-2.87c.44,3.39-1.24,5.73-4.36,6.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.83,136a5,5,0,0,0,2.7-3.31,3.8,3.8,0,0,0-2.23,1.17A2.74,2.74,0,0,0,256.83,136Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.69,125.22h-3.25a1.63,1.63,0,0,1-1.62-1.62v-2a1.63,1.63,0,0,1,1.62-1.63h3.25a1.62,1.62,0,0,1,1.62,1.63v2A1.62,1.62,0,0,1,250.69,125.22Zm-3.25-4.33a.65.65,0,0,0-.65.66v2a.65.65,0,0,0,.65.65h3.25a.66.66,0,0,0,.66-.65v-2a.66.66,0,0,0-.66-.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,125.22H255.2a1.63,1.63,0,0,1-1.63-1.62v-2a1.63,1.63,0,0,1,1.63-1.63h3.24a1.63,1.63,0,0,1,1.63,1.63v2A1.63,1.63,0,0,1,258.44,125.22Zm-3.24-4.33a.65.65,0,0,0-.66.66v2a.65.65,0,0,0,.66.65h3.24a.66.66,0,0,0,.66-.65v-2a.66.66,0,0,0-.66-.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.83,
    y: 122.09,
    width: 2.23,
    height: 0.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.09,
    y: 122.09,
    width: 8.35,
    height: 0.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.37,159.88c-1.3,3.2-6.33,18.61-7.75,37.79q.63,2.73,1.51,5.49c1.13-1.68,3-3.5,4.29-5.17.69-17.25,2.29-33.82,3.7-37.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.3 162.53 255.06 158.3 258.12 157.22 260.25 158.75 256.3 162.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12,157.22s1.76,2.65,3.87,5.3c3.54-1.52,11.89-5.68,11.95-10.18a4.53,4.53,0,0,0-2-2.27A48.52,48.52,0,0,1,258.12,157.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12,157.22a23.6,23.6,0,0,0-4.83,4.55c-2.3-1.91-.22-10.1.78-10.94a5.73,5.73,0,0,1,3.42-.83S254.3,155.93,258.12,157.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.04 411.81 219.07 410.72 220.18 391.25 228.13 392.35 227.04 411.81",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.13 392.35 220.18 391.25 219.49 403.32 227.51 403.32 228.13 392.35",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.47,409.76l9-.56a.58.58,0,0,1,.63.51h0l.88,7.1a1.42,1.42,0,0,1-1.31,1.5c-3.14.15-4.65.06-8.61.27-2.44.15-7.23.67-10.58.34s-2.94-3.63-1.5-3.79c3.44-.39,8-2.91,10.14-4.83A2.25,2.25,0,0,1,218.47,409.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.28,410.74h0c0-.14-.14-2.41-1-3.14a1.21,1.21,0,0,0-.89-.21.75.75,0,0,0-.68.61,2.91,2.91,0,0,0,.79,1.84,3.27,3.27,0,0,0-2.23-.41.7.7,0,0,0-.4.56,1,1,0,0,0,.29,1,2.12,2.12,0,0,0,1.53.3,9.91,9.91,0,0,0,2.09-.41h.07l0-.06s.19,0,.2-.08l.17,0Zm-2.22-2.67c0-.11.08-.24.34-.29h.09a.56.56,0,0,1,.41.14,4,4,0,0,1,.68,2.46l-.17-.09A3.83,3.83,0,0,1,216.06,408.07Zm-1.64,2.65a.68.68,0,0,1-.17-.65.34.34,0,0,1,.19-.28c.52-.24,1.89.35,2.86.89C215.88,411.05,214.83,411.07,214.42,410.72Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.7 411.81 277.73 410.72 276.63 391.79 284.58 392.89 285.7 411.81",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.58 392.89 276.63 391.8 277.3 403.32 285.2 403.32 284.58 392.89",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.13,409.76l9-.56a.58.58,0,0,1,.63.51h0l.88,7.1a1.42,1.42,0,0,1-1.31,1.5c-3.14.15-4.65.06-8.61.27-2.44.15-7.23.67-10.58.34s-2.94-3.63-1.5-3.79c3.44-.39,8-2.91,10.14-4.83A2.25,2.25,0,0,1,277.13,409.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.94,410.74h0c0-.14-.14-2.41-1-3.14a1.21,1.21,0,0,0-.89-.21.75.75,0,0,0-.68.61,2.91,2.91,0,0,0,.79,1.84,3.27,3.27,0,0,0-2.23-.41.7.7,0,0,0-.4.56,1,1,0,0,0,.29,1,2.12,2.12,0,0,0,1.53.3,9.91,9.91,0,0,0,2.09-.41h.07s0,0,0-.06.19,0,.2-.08l.17,0Zm-2.22-2.67c0-.11.08-.24.34-.29h.09a.56.56,0,0,1,.41.14,4,4,0,0,1,.68,2.46l-.17-.09A3.83,3.83,0,0,1,274.72,408.07Zm-1.64,2.65a.68.68,0,0,1-.17-.65.34.34,0,0,1,.19-.28c.52-.24,1.89.35,2.86.89C274.54,411.05,273.49,411.07,273.08,410.72Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.25,231.09v30.16c-9.57,24.82-24.16,65.79-26.69,79.21s-1.88,29.75-6.39,59.43l-15.69.36s-1.09-33.92,1.23-58.82S239.2,231.09,239.2,231.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11,231.09c1.82,13.38-4.5,102.84-2.93,115.29s3.45,23.74,5.46,53.87H272.88s-7.71-28.55-11.67-53.55-6.23-91.28-3.62-115.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,302.81s1.5-13.9,1.9-19.56,4.24-21.35,4.24-21.35l.65,22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.61,180.91c4.64-3.39,8.16-7.22,9.95-11.73a36.78,36.78,0,0,0-.86,5.71A73,73,0,0,1,224.61,180.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,185.35c-.61-5.83-1.48-13.82-2.51-18.71a44.07,44.07,0,0,0,3.7,2.92",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.27,126.38a22.22,22.22,0,1,0-31.77,20.06c-.32-1-.66-2.07-1-3.2s-.73-2.21-1.15-3.4A54.6,54.6,0,0,1,174,138a60.52,60.52,0,0,1,8.29-.87c3.59,0,7.72.38,7.72.38s.59.14,1,3.95c.07.75.14,1.72.19,2.88A22.18,22.18,0,0,0,200.27,126.38Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.27,126.38a22.22,22.22,0,1,0-31.77,20.06c-.32-1-.66-2.07-1-3.2s-.73-2.21-1.15-3.4A54.6,54.6,0,0,1,174,138a60.52,60.52,0,0,1,8.29-.87c3.59,0,7.72.38,7.72.38s.59.14,1,3.95c.07.75.14,1.72.19,2.88A22.18,22.18,0,0,0,200.27,126.38Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,116.87l-6.22-2.46s-6.79-.36-8,3.16-.81,9.58-1.69,14.88c-.61,3.73-4.38,6.05-6.55,9.4a22.33,22.33,0,0,0,2.1,1.91,22,22,0,0,0,13.82,4.83,22.33,22.33,0,0,0,4.13-.39c1.42-5.53,2.8-13.17,4.18-20.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,116.87a6.14,6.14,0,0,1,2.59,5.23c-.14,3.52-.69,6.92-.37,9.06.37,2.53-1.22,6.14-1.22,6.14a20.44,20.44,0,0,0-.63-3.38s0,.92-1.23,1.25-11.05.58-13.26-1.25,2.41-16.59,4.95-17.46S184.55,116.87,184.55,116.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,137.49s-4.13-.41-7.72-.38A60.52,60.52,0,0,0,174,138a54.6,54.6,0,0,0-7.67,1.86c.42,1.19.8,2.33,1.15,3.4s.72,2.19,1,3.2a22.23,22.23,0,0,0,22.64-2.12c0-1.16-.12-2.13-.19-2.88C190.58,137.63,190,137.49,190,137.49Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,137.49s-4.13-.41-7.72-.38A60.52,60.52,0,0,0,174,138a54.6,54.6,0,0,0-7.67,1.86c.42,1.19.8,2.33,1.15,3.4s.72,2.19,1,3.2a22.23,22.23,0,0,0,22.64-2.12c0-1.16-.12-2.13-.19-2.88C190.58,137.63,190,137.49,190,137.49Z",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.75,141.19c-4.56-.58-5.92-2.53-5.92-2.53,2.89-2.72.49-7.44.49-7.44l5.47,1a16.69,16.69,0,0,0-.21,2.31c0,3.32,1.46,3.35,1.46,3.35C183,139.7,180.75,141.19,180.75,141.19Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.79,132.24a16.69,16.69,0,0,0-.21,2.31,6.09,6.09,0,0,1-5.26-3.33Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.61,139.17s5.34,4.33,10.32,4.26,6.72-5.66,6.72-5.66A28.29,28.29,0,0,0,170.61,139.17Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.06,117.79c4.49.77,5.53,3.42,5.07,8.11-.58,5.85-2.56,9.74-8,7.55C170.82,130.47,173.6,116.52,181.06,117.79Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.27,125.15a9.36,9.36,0,0,0,1,2.08,1.26,1.26,0,0,1-1.28.31Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.58,124.31c-.05.37-.3.64-.55.61s-.4-.37-.34-.74.29-.64.54-.6S180.63,123.94,180.58,124.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.13,123.58l.85-.2S180.48,124,180.13,123.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,124.91c-.06.37-.3.64-.55.61s-.4-.37-.35-.74.3-.64.55-.61S185.25,124.54,185.2,124.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.74,124.18l.85-.2S185.09,124.6,184.74,124.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,121.74a.22.22,0,0,1-.15-.06.2.2,0,0,1,0-.28,2.56,2.56,0,0,1,2.25-.38.19.19,0,0,1-.11.37,2.19,2.19,0,0,0-1.88.31A.2.2,0,0,1,179,121.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.09,122.44a.19.19,0,0,1-.13,0,2,2,0,0,0-1.56-.63.19.19,0,1,1-.07-.38,2.31,2.31,0,0,1,1.89.72.2.2,0,0,1,0,.28A.2.2,0,0,1,186.09,122.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.86,124.53s2.73-3.34,2.9-6.24c0,0,9.52-2.12,8.42,7,0,0,2.24-7.87-5.45-9.37s-8.61,13.24-5.2,17.28C175.53,133.19,173.17,126.61,174.86,124.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.43,125.6a2,2,0,0,0-1.81-2.16c-1.42-.09-2.57,2.65.78,3.93C174.88,127.56,175.24,127.12,175.43,125.6Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.81,117.28a13.6,13.6,0,0,0,4.06,3A45.85,45.85,0,0,0,187,121.9c-.84,4.12-.66,7.53,1.32,9.67-.73-1.19.44-10.45.32-11.24-.29-1.88-2.16-3.09-4.32-4.55a9.67,9.67,0,0,0-5.36-1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53,118.27v5.28a6.16,6.16,0,0,0,.54,4.83,29.71,29.71,0,0,1,.46-6.13l1.76-3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.08,129.07a3.91,3.91,0,0,1-2.82-1.16.13.13,0,0,1,0-.18.12.12,0,0,1,.18,0,3.79,3.79,0,0,0,3.12,1,.12.12,0,0,1,.14.11.13.13,0,0,1-.11.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.31,139.84a8.86,8.86,0,0,0-2.48,3.59,23.62,23.62,0,0,0,4.67,3Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.31,139.84a8.86,8.86,0,0,0-2.48,3.59,23.62,23.62,0,0,0,4.67,3Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,137.49l1.15,6.83a22.39,22.39,0,0,0,4.26-4.07A12.15,12.15,0,0,0,190,137.49Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,137.49l1.15,6.83a22.39,22.39,0,0,0,4.26-4.07A12.15,12.15,0,0,0,190,137.49Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.64,394.19a3,3,0,0,0-2.39-4.27,6.36,6.36,0,0,0-2-7,1.47,1.47,0,0,0-.87-.39,1.76,1.76,0,0,0-1,.41l-5.57,4a3.31,3.31,0,0,0-1.11,1.09c-1.14,2.21,3,5,1.28,6.86-.48.52-1.26.63-1.87,1-1.32.83-1.48,2.65-2.1,4.09s-2.78,2.55-3.6,1.22c.61-1.38-1.24-2.57-2.73-2.74s-3.06-.26-3.89-1.66c-2.12,1.85-6.88-3.33-6.77-5.41-1.75.13-2.94,1.76-3.32,3.4a25.05,25.05,0,0,0-.18,5.2c-.05,3.38-1.14,6.7-1.08,10.08,0,2.63,1.06,5.55,3.47,6.61a9.05,9.05,0,0,0,3.74.5l27.43-.18a4,4,0,0,0,1.92-.32c1.24-.64,1.5-2.27,1.62-3.66l1.47-17.88Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.64,394.19a3,3,0,0,0-2.39-4.27,6.36,6.36,0,0,0-2-7,1.47,1.47,0,0,0-.87-.39,1.76,1.76,0,0,0-1,.41l-5.57,4a3.31,3.31,0,0,0-1.11,1.09c-1.14,2.21,3,5,1.28,6.86-.48.52-1.26.63-1.87,1-1.32.83-1.48,2.65-2.1,4.09s-2.78,2.55-3.6,1.22c.61-1.38-1.24-2.57-2.73-2.74s-3.06-.26-3.89-1.66c-2.12,1.85-6.88-3.33-6.77-5.41-1.75.13-2.94,1.76-3.32,3.4a25.05,25.05,0,0,0-.18,5.2c-.05,3.38-1.14,6.7-1.08,10.08,0,2.63,1.06,5.55,3.47,6.61a9.05,9.05,0,0,0,3.74.5l27.43-.18a4,4,0,0,0,1.92-.32c1.24-.64,1.5-2.27,1.62-3.66l1.47-17.88Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,365.2H146.68l.35,4.3.25,3.07.65,8,.37,4.59.49,6.11.21,2.62.07.78.25,3.08.34,4.22.21,2.62.22,2.66.25,3.08.19,2.33.21,2.62.09,1.14h39.06l.09-1.14.21-2.61.19-2.35.25-3.08.22-2.65.21-2.62.34-4.23.25-3.07.06-.78.21-2.62.5-6.11.37-4.58.64-8,.25-3.07.35-4.3ZM191.8,368h0l-.82-.82h.89Zm-.21,2.61-.08,1-3.81,3.81-4.37-4.37,3.91-3.91h.92Zm-1.1,13.62L187.7,387l-4.37-4.37,4.37-4.36,3,3ZM150,381.33h0l3-3,4.37,4.36L153,387l-2.78-2.79Zm36.3-4.44-4.37,4.37-4.37-4.37,4.37-4.37Zm-6.87-9.69h5l-2.5,2.5Zm1.08,15.47L176.14,387l-4.37-4.37,4.37-4.36ZM166,388.45l4.37-4.36,4.36,4.36-4.36,4.37Zm2.95,5.78-4.37,4.37-4.36-4.36,4.37-4.37Zm7.2-4.36,4.36,4.37-4.36,4.36-4.37-4.37Zm-5.78-8.61L166,376.89l4.37-4.37,4.36,4.37Zm-1.42,1.41L164.58,387l-4.37-4.37,4.37-4.36Zm-10.15-1.41-4.36-4.37,4.36-4.37,4.37,4.37Zm0,2.83,4.37,4.36-4.37,4.37-4.36-4.37ZM163.16,400l-4.37,4.36L154.43,400l4.36-4.37Zm1.41,1.41,4.37,4.37-4.36,4.37-4.37-4.37ZM166,400l4.37-4.37,4.36,4.37-4.36,4.36Zm10.15,1.41,4.36,4.37-4.36,4.37-4.37-4.37Zm5.78,5.78,4.37,4.37-2.83,2.83h-3.08l-2.83-2.83ZM177.55,400l4.37-4.37,4.37,4.37-4.37,4.36Zm0-11.57,4.37-4.36,4.37,4.36-4.37,4.37Zm2.95-17.34-4.36,4.37-4.37-4.37,3.91-3.91h.92Zm-10.14-1.41-2.5-2.5h5Zm-1.42,1.41-4.36,4.37-4.37-4.37,3.91-3.91H165Zm-7.65-3.91-2.5,2.5-2.49-2.5Zm-7.82,0,3.91,3.91L153,375.48l-3.8-3.81-.08-1,3.42-3.43Zm-3.74,0-.81.81h0l-.07-.81Zm-.27,7.55,2.14,2.14-1.82,1.82Zm1.19,14.65-.17-2.07h0l1.12,1.12-.95.95Zm.21,2.63,2.15-2.16,4.37,4.37L153,398.6l-1.76-1.76Zm.65,8.08v-.19l.1.1-.09.09Zm.76,9.31-.55-6.7,1.29-1.29,4.37,4.37L153,410.16l-.74-.74Zm.4,5-.08-1L153,413l1.42,1.42Zm1.76-2.83,4.36-4.37,4.37,4.37-2.83,2.83h-3.08Zm8.73,2.83,1.42-1.42,1.42,1.42Zm5.66,0L166,411.58l4.37-4.37,4.36,4.37-2.82,2.83Zm5.9,0,1.42-1.42,1.42,1.42Zm13.32,0h-1.76L187.7,413l.42.42Zm.41-5-.75.74-4.37-4.36,4.37-4.37,1.29,1.29Zm.77-9.51,0,.2-.09-.09.11-.11Zm.25-3.07-1.77,1.76-4.37-4.36,4.37-4.37,2.16,2.16Zm.6-7.43-1-1,1.13-1.12Zm1.19-14.67-.32,4-1.83-1.83,2.15-2.15Z",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.24,365.2H146.68l.35,4.3.25,3.07.65,8,.37,4.59.49,6.11.21,2.62.07.78.25,3.08.34,4.22.21,2.62.22,2.66.25,3.08.19,2.33.21,2.62.09,1.14h39.06l.09-1.14.21-2.61.19-2.35.25-3.08.22-2.65.21-2.62.34-4.23.25-3.07.06-.78.21-2.62.5-6.11.37-4.58.64-8,.25-3.07.35-4.3ZM191.8,368h0l-.82-.82h.89Zm-.21,2.61-.08,1-3.81,3.81-4.37-4.37,3.91-3.91h.92Zm-1.1,13.62L187.7,387l-4.37-4.37,4.37-4.36,3,3ZM150,381.33h0l3-3,4.37,4.36L153,387l-2.78-2.79Zm36.3-4.44-4.37,4.37-4.37-4.37,4.37-4.37Zm-6.87-9.69h5l-2.5,2.5Zm1.08,15.47L176.14,387l-4.37-4.37,4.37-4.36ZM166,388.45l4.37-4.36,4.36,4.36-4.36,4.37Zm2.95,5.78-4.37,4.37-4.36-4.36,4.37-4.37Zm7.2-4.36,4.36,4.37-4.36,4.36-4.37-4.37Zm-5.78-8.61L166,376.89l4.37-4.37,4.36,4.37Zm-1.42,1.41L164.58,387l-4.37-4.37,4.37-4.36Zm-10.15-1.41-4.36-4.37,4.36-4.37,4.37,4.37Zm0,2.83,4.37,4.36-4.37,4.37-4.36-4.37ZM163.16,400l-4.37,4.36L154.43,400l4.36-4.37Zm1.41,1.41,4.37,4.37-4.36,4.37-4.37-4.37ZM166,400l4.37-4.37,4.36,4.37-4.36,4.36Zm10.15,1.41,4.36,4.37-4.36,4.37-4.37-4.37Zm5.78,5.78,4.37,4.37-2.83,2.83h-3.08l-2.83-2.83ZM177.55,400l4.37-4.37,4.37,4.37-4.37,4.36Zm0-11.57,4.37-4.36,4.37,4.36-4.37,4.37Zm2.95-17.34-4.36,4.37-4.37-4.37,3.91-3.91h.92Zm-10.14-1.41-2.5-2.5h5Zm-1.42,1.41-4.36,4.37-4.37-4.37,3.91-3.91H165Zm-7.65-3.91-2.5,2.5-2.49-2.5Zm-7.82,0,3.91,3.91L153,375.48l-3.8-3.81-.08-1,3.42-3.43Zm-3.74,0-.81.81h0l-.07-.81Zm-.27,7.55,2.14,2.14-1.82,1.82Zm1.19,14.65-.17-2.07h0l1.12,1.12-.95.95Zm.21,2.63,2.15-2.16,4.37,4.37L153,398.6l-1.76-1.76Zm.65,8.08v-.19l.1.1-.09.09Zm.76,9.31-.55-6.7,1.29-1.29,4.37,4.37L153,410.16l-.74-.74Zm.4,5-.08-1L153,413l1.42,1.42Zm1.76-2.83,4.36-4.37,4.37,4.37-2.83,2.83h-3.08Zm8.73,2.83,1.42-1.42,1.42,1.42Zm5.66,0L166,411.58l4.37-4.37,4.36,4.37-2.82,2.83Zm5.9,0,1.42-1.42,1.42,1.42Zm13.32,0h-1.76L187.7,413l.42.42Zm.41-5-.75.74-4.37-4.36,4.37-4.37,1.29,1.29Zm.77-9.51,0,.2-.09-.09.11-.11Zm.25-3.07-1.77,1.76-4.37-4.36,4.37-4.37,2.16,2.16Zm.6-7.43-1-1,1.13-1.12Zm1.19-14.67-.32,4-1.83-1.83,2.15-2.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 363.41,
    width: 52.8,
    height: 5.57,
    rx: 1.64,
    transform: "translate(340.71 732.4) rotate(180)",
    style: {
      fill: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.76,
    y: 413.41,
    width: 45.19,
    height: 5.57,
    rx: 1.64,
    style: {
      fill: "#EEEEEE"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectuser);
export default __webpack_public_path__ + "static/media/selectuser.e6bad24ad81c2357bd7498f16ae0366c.svg";
export { ForwardRef as ReactComponent };